exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".st {\n  enable-background:new 0 0 652 652;\n}\n.st0 {\n  fill:#F26832;\n}\n.st1 {\n  fill:#53297F;\n}\n", ""]);
